export default __webpack_public_path__ + "static/media/acidic-ph-scale.37cf1db7.png";